import { ServiceType, stackIntercept } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
//#region src/ntb/service.ts
/**
* @generated from protobuf enum ttab.ntb.Orientation
*/
let Orientation = /* @__PURE__ */ function(Orientation) {
	/**
	* @generated from protobuf enum value: ORIENTATION_UNSPECIFIED = 0;
	*/
	Orientation[Orientation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: ORIENTATION_HORIZONTAL = 1;
	*/
	Orientation[Orientation["HORIZONTAL"] = 1] = "HORIZONTAL";
	/**
	* @generated from protobuf enum value: ORIENTATION_VERTICAL = 2;
	*/
	Orientation[Orientation["VERTICAL"] = 2] = "VERTICAL";
	/**
	* @generated from protobuf enum value: ORIENTATION_SQUARE = 3;
	*/
	Orientation[Orientation["SQUARE"] = 3] = "SQUARE";
	return Orientation;
}({});
/**
* @generated from protobuf enum ttab.ntb.Location
*/
let Location = /* @__PURE__ */ function(Location) {
	/**
	* @generated from protobuf enum value: LOCATION_UNSPECIFIED = 0;
	*/
	Location[Location["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: LOCATION_IN_GALLERY = 1;
	*/
	Location[Location["IN_GALLERY"] = 1] = "IN_GALLERY";
	/**
	* @generated from protobuf enum value: LOCATION_NOT_IN_GALLERY = 2;
	*/
	Location[Location["NOT_IN_GALLERY"] = 2] = "NOT_IN_GALLERY";
	/**
	* @generated from protobuf enum value: LOCATION_IN_COLLECTIONS = 3;
	*/
	Location[Location["IN_COLLECTIONS"] = 3] = "IN_COLLECTIONS";
	/**
	* @generated from protobuf enum value: LOCATION_NOT_IN_COLLECTIONS = 4;
	*/
	Location[Location["NOT_IN_COLLECTIONS"] = 4] = "NOT_IN_COLLECTIONS";
	/**
	* @generated from protobuf enum value: LOCATION_ALL_ORGANIZATIONS = 5;
	*/
	Location[Location["ALL_ORGANIZATIONS"] = 5] = "ALL_ORGANIZATIONS";
	return Location;
}({});
/**
* @generated from protobuf enum ttab.ntb.Origin
*/
let Origin = /* @__PURE__ */ function(Origin) {
	/**
	* @generated from protobuf enum value: ORIGIN_UNSPECIFIED = 0;
	*/
	Origin[Origin["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: ORIGIN_UPLOAD = 1;
	*/
	Origin[Origin["UPLOAD"] = 1] = "UPLOAD";
	/**
	* @generated from protobuf enum value: ORIGIN_GUEST = 2;
	*/
	Origin[Origin["GUEST"] = 2] = "GUEST";
	/**
	* @generated from protobuf enum value: ORIGIN_GUESTFTP = 3;
	*/
	Origin[Origin["GUESTFTP"] = 3] = "GUESTFTP";
	/**
	* @generated from protobuf enum value: ORIGIN_EMAIL = 4;
	*/
	Origin[Origin["EMAIL"] = 4] = "EMAIL";
	/**
	* @generated from protobuf enum value: ORIGIN_IMPORT = 5;
	*/
	Origin[Origin["IMPORT"] = 5] = "IMPORT";
	/**
	* @generated from protobuf enum value: ORIGIN_FTP = 6;
	*/
	Origin[Origin["FTP"] = 6] = "FTP";
	/**
	* @generated from protobuf enum value: ORIGIN_LTR = 7;
	*/
	Origin[Origin["LTR"] = 7] = "LTR";
	/**
	* @generated from protobuf enum value: ORIGIN_PS = 8;
	*/
	Origin[Origin["PS"] = 8] = "PS";
	/**
	* @generated from protobuf enum value: ORIGIN_CMS = 9;
	*/
	Origin[Origin["CMS"] = 9] = "CMS";
	return Origin;
}({});
/**
* @generated from protobuf enum ttab.ntb.FileType
*/
let FileType = /* @__PURE__ */ function(FileType) {
	/**
	* @generated from protobuf enum value: FILE_TYPE_UNSPECIFIED = 0;
	*/
	FileType[FileType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* @generated from protobuf enum value: FILE_TYPE_IMAGE = 1;
	*/
	FileType[FileType["IMAGE"] = 1] = "IMAGE";
	/**
	* @generated from protobuf enum value: FILE_TYPE_VIDEO = 2;
	*/
	FileType[FileType["VIDEO"] = 2] = "VIDEO";
	/**
	* @generated from protobuf enum value: FILE_TYPE_PDF = 3;
	*/
	FileType[FileType["PDF"] = 3] = "PDF";
	/**
	* @generated from protobuf enum value: FILE_TYPE_VECTOR = 4;
	*/
	FileType[FileType["VECTOR"] = 4] = "VECTOR";
	/**
	* @generated from protobuf enum value: FILE_TYPE_PHOTOSHOP = 5;
	*/
	FileType[FileType["PHOTOSHOP"] = 5] = "PHOTOSHOP";
	return FileType;
}({});
/**
* @generated from protobuf enum ttab.ntb.TimestampPrecision
*/
let TimestampPrecision = /* @__PURE__ */ function(TimestampPrecision) {
	/**
	* @generated from protobuf enum value: TS_PRECISION_UNKNOWN = 0;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_UNKNOWN"] = 0] = "TS_PRECISION_UNKNOWN";
	/**
	* @generated from protobuf enum value: TS_PRECISION_FULL = 1;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_FULL"] = 1] = "TS_PRECISION_FULL";
	/**
	* @generated from protobuf enum value: TS_PRECISION_MINUTE = 2;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_MINUTE"] = 2] = "TS_PRECISION_MINUTE";
	/**
	* @generated from protobuf enum value: TS_PRECISION_HOUR = 3;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_HOUR"] = 3] = "TS_PRECISION_HOUR";
	/**
	* @generated from protobuf enum value: TS_PRECISION_DAY = 4;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_DAY"] = 4] = "TS_PRECISION_DAY";
	/**
	* @generated from protobuf enum value: TS_PRECISION_MONTH = 5;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_MONTH"] = 5] = "TS_PRECISION_MONTH";
	/**
	* @generated from protobuf enum value: TS_PRECISION_YEAR = 6;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_YEAR"] = 6] = "TS_PRECISION_YEAR";
	/**
	* @generated from protobuf enum value: TS_PRECISION_DECADE = 7;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_DECADE"] = 7] = "TS_PRECISION_DECADE";
	/**
	* @generated from protobuf enum value: TS_PRECISION_CENTURY = 8;
	*/
	TimestampPrecision[TimestampPrecision["TS_PRECISION_CENTURY"] = 8] = "TS_PRECISION_CENTURY";
	return TimestampPrecision;
}({});
/**
* @generated from protobuf enum ttab.ntb.PreviewType
*/
let PreviewType = /* @__PURE__ */ function(PreviewType) {
	/**
	* @generated from protobuf enum value: PREVIEW_UNKNOWN = 0;
	*/
	PreviewType[PreviewType["PREVIEW_UNKNOWN"] = 0] = "PREVIEW_UNKNOWN";
	/**
	* @generated from protobuf enum value: PREVIEW_IMAGE = 1;
	*/
	PreviewType[PreviewType["PREVIEW_IMAGE"] = 1] = "PREVIEW_IMAGE";
	/**
	* @generated from protobuf enum value: PREVIEW_VIDEO = 2;
	*/
	PreviewType[PreviewType["PREVIEW_VIDEO"] = 2] = "PREVIEW_VIDEO";
	return PreviewType;
}({});
/**
* LangParameterTranslate controls how text inside HTML lang-tagged elements
* is handled during translation.
*
* @generated from protobuf enum ttab.ntb.LangParameterTranslate
*/
let LangParameterTranslate = /* @__PURE__ */ function(LangParameterTranslate) {
	/**
	* @generated from protobuf enum value: LANG_PARAMETER_TRANSLATE_UNSPECIFIED = 0;
	*/
	LangParameterTranslate[LangParameterTranslate["UNSPECIFIED"] = 0] = "UNSPECIFIED";
	/**
	* Translate only tags where the lang attribute matches the source language.
	*
	* @generated from protobuf enum value: LANG_PARAMETER_TRANSLATE_ORIGIN = 1;
	*/
	LangParameterTranslate[LangParameterTranslate["ORIGIN"] = 1] = "ORIGIN";
	/**
	* Ignore lang attributes and translate all text.
	*
	* @generated from protobuf enum value: LANG_PARAMETER_TRANSLATE_ALL = 2;
	*/
	LangParameterTranslate[LangParameterTranslate["ALL"] = 2] = "ALL";
	/**
	* Do not translate any text inside lang-tagged elements.
	*
	* @generated from protobuf enum value: LANG_PARAMETER_TRANSLATE_NONE = 3;
	*/
	LangParameterTranslate[LangParameterTranslate["NONE"] = 3] = "NONE";
	return LangParameterTranslate;
}({});
var GetAssignmentRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetAssignmentRequest", [{
			no: 1,
			name: "commission_code",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.commissionCode = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.commissionCode = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.commissionCode !== "") writer.tag(1, WireType.LengthDelimited).string(message.commissionCode);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetAssignmentRequest
*/
const GetAssignmentRequest = new GetAssignmentRequest$Type();
var GetAssignmentResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetAssignmentResponse", [{
			no: 1,
			name: "planning_uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "assignment_uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.planningUuid = "";
		message.assignmentUuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.planningUuid = reader.string();
					break;
				case 2:
					message.assignmentUuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.planningUuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.planningUuid);
		if (message.assignmentUuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.assignmentUuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetAssignmentResponse
*/
const GetAssignmentResponse = new GetAssignmentResponse$Type();
var ListAssignmentsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.ListAssignmentsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.ListAssignmentsRequest
*/
const ListAssignmentsRequest = new ListAssignmentsRequest$Type();
var Assignment$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Assignment", [
			{
				no: 1,
				name: "planning_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "assignment_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "assignee_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "assignee_name",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "commission_code",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.planningUuid = "";
		message.assignmentUuid = "";
		message.assigneeUuid = "";
		message.assigneeName = "";
		message.commissionCode = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.planningUuid = reader.string();
					break;
				case 2:
					message.assignmentUuid = reader.string();
					break;
				case 3:
					message.assigneeUuid = reader.string();
					break;
				case 4:
					message.assigneeName = reader.string();
					break;
				case 5:
					message.commissionCode = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.planningUuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.planningUuid);
		if (message.assignmentUuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.assignmentUuid);
		if (message.assigneeUuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.assigneeUuid);
		if (message.assigneeName !== "") writer.tag(4, WireType.LengthDelimited).string(message.assigneeName);
		if (message.commissionCode !== "") writer.tag(5, WireType.LengthDelimited).string(message.commissionCode);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Assignment
*/
const Assignment = new Assignment$Type();
var ListAssignmentsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.ListAssignmentsResponse", [{
			no: 1,
			name: "assignments",
			kind: "message",
			repeat: 2,
			T: () => Assignment
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.assignments = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.assignments.push(Assignment.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.assignments.length; i++) Assignment.internalBinaryWrite(message.assignments[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.ListAssignmentsResponse
*/
const ListAssignmentsResponse = new ListAssignmentsResponse$Type();
var GetItemRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetItemRequest", [{
			no: 1,
			name: "archive",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "id",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.archive = "";
		message.id = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.archive = reader.string();
					break;
				case 2:
					message.id = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.archive !== "") writer.tag(1, WireType.LengthDelimited).string(message.archive);
		if (message.id !== "") writer.tag(2, WireType.LengthDelimited).string(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetItemRequest
*/
const GetItemRequest = new GetItemRequest$Type();
var GetItemResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetItemResponse", [{
			no: 1,
			name: "item",
			kind: "message",
			T: () => MediaItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.item = MediaItem.internalBinaryRead(reader, reader.uint32(), options, message.item);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.item) MediaItem.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetItemResponse
*/
const GetItemResponse = new GetItemResponse$Type();
var SearchRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.SearchRequest", [
			{
				no: 1,
				name: "archive",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "limit",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "offset",
				kind: "scalar",
				T: 5
			},
			{
				no: 4,
				name: "sort",
				kind: "message",
				T: () => Sort
			},
			{
				no: 5,
				name: "query",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "item_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "city",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "country",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "creator",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "ids",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 11,
				name: "keywords",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 12,
				name: "collections",
				kind: "scalar",
				repeat: 1,
				T: 5
			},
			{
				no: 13,
				name: "albums",
				kind: "scalar",
				repeat: 1,
				T: 5
			},
			{
				no: 14,
				name: "categories",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 15,
				name: "locations",
				kind: "scalar",
				T: 9
			},
			{
				no: 16,
				name: "job_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 17,
				name: "orientation",
				kind: "enum",
				T: () => [
					"ttab.ntb.Orientation",
					Orientation,
					"ORIENTATION_"
				]
			},
			{
				no: 18,
				name: "search_after",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 19,
				name: "origins",
				kind: "enum",
				repeat: 1,
				T: () => [
					"ttab.ntb.Origin",
					Origin,
					"ORIGIN_"
				]
			},
			{
				no: 20,
				name: "file_type",
				kind: "enum",
				T: () => [
					"ttab.ntb.FileType",
					FileType,
					"FILE_TYPE_"
				]
			},
			{
				no: 21,
				name: "created_min",
				kind: "scalar",
				T: 9
			},
			{
				no: 22,
				name: "created_max",
				kind: "scalar",
				T: 9
			},
			{
				no: 23,
				name: "outside_subscription",
				kind: "scalar",
				T: 8
			},
			{
				no: 24,
				name: "editorial_topics",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 25,
				name: "distributor_names",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 26,
				name: "events",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 27,
				name: "subject_terms",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 28,
				name: "persons",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.archive = "";
		message.limit = 0;
		message.offset = 0;
		message.query = "";
		message.itemId = "";
		message.city = "";
		message.country = "";
		message.creator = "";
		message.ids = [];
		message.keywords = [];
		message.collections = [];
		message.albums = [];
		message.categories = [];
		message.locations = "";
		message.jobId = "";
		message.orientation = 0;
		message.searchAfter = [];
		message.origins = [];
		message.fileType = 0;
		message.createdMin = "";
		message.createdMax = "";
		message.outsideSubscription = false;
		message.editorialTopics = [];
		message.distributorNames = [];
		message.events = [];
		message.subjectTerms = [];
		message.persons = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.archive = reader.string();
					break;
				case 2:
					message.limit = reader.int32();
					break;
				case 3:
					message.offset = reader.int32();
					break;
				case 4:
					message.sort = Sort.internalBinaryRead(reader, reader.uint32(), options, message.sort);
					break;
				case 5:
					message.query = reader.string();
					break;
				case 6:
					message.itemId = reader.string();
					break;
				case 7:
					message.city = reader.string();
					break;
				case 8:
					message.country = reader.string();
					break;
				case 9:
					message.creator = reader.string();
					break;
				case 10:
					message.ids.push(reader.string());
					break;
				case 11:
					message.keywords.push(reader.string());
					break;
				case 12:
					if (wireType === WireType.LengthDelimited) for (let e = reader.int32() + reader.pos; reader.pos < e;) message.collections.push(reader.int32());
					else message.collections.push(reader.int32());
					break;
				case 13:
					if (wireType === WireType.LengthDelimited) for (let e = reader.int32() + reader.pos; reader.pos < e;) message.albums.push(reader.int32());
					else message.albums.push(reader.int32());
					break;
				case 14:
					message.categories.push(reader.string());
					break;
				case 15:
					message.locations = reader.string();
					break;
				case 16:
					message.jobId = reader.string();
					break;
				case 17:
					message.orientation = reader.int32();
					break;
				case 18:
					message.searchAfter.push(reader.string());
					break;
				case 19:
					if (wireType === WireType.LengthDelimited) for (let e = reader.int32() + reader.pos; reader.pos < e;) message.origins.push(reader.int32());
					else message.origins.push(reader.int32());
					break;
				case 20:
					message.fileType = reader.int32();
					break;
				case 21:
					message.createdMin = reader.string();
					break;
				case 22:
					message.createdMax = reader.string();
					break;
				case 23:
					message.outsideSubscription = reader.bool();
					break;
				case 24:
					message.editorialTopics.push(reader.string());
					break;
				case 25:
					message.distributorNames.push(reader.string());
					break;
				case 26:
					message.events.push(reader.string());
					break;
				case 27:
					message.subjectTerms.push(reader.string());
					break;
				case 28:
					message.persons.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.archive !== "") writer.tag(1, WireType.LengthDelimited).string(message.archive);
		if (message.limit !== 0) writer.tag(2, WireType.Varint).int32(message.limit);
		if (message.offset !== 0) writer.tag(3, WireType.Varint).int32(message.offset);
		if (message.sort) Sort.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.query !== "") writer.tag(5, WireType.LengthDelimited).string(message.query);
		if (message.itemId !== "") writer.tag(6, WireType.LengthDelimited).string(message.itemId);
		if (message.city !== "") writer.tag(7, WireType.LengthDelimited).string(message.city);
		if (message.country !== "") writer.tag(8, WireType.LengthDelimited).string(message.country);
		if (message.creator !== "") writer.tag(9, WireType.LengthDelimited).string(message.creator);
		for (let i = 0; i < message.ids.length; i++) writer.tag(10, WireType.LengthDelimited).string(message.ids[i]);
		for (let i = 0; i < message.keywords.length; i++) writer.tag(11, WireType.LengthDelimited).string(message.keywords[i]);
		if (message.collections.length) {
			writer.tag(12, WireType.LengthDelimited).fork();
			for (let i = 0; i < message.collections.length; i++) writer.int32(message.collections[i]);
			writer.join();
		}
		if (message.albums.length) {
			writer.tag(13, WireType.LengthDelimited).fork();
			for (let i = 0; i < message.albums.length; i++) writer.int32(message.albums[i]);
			writer.join();
		}
		for (let i = 0; i < message.categories.length; i++) writer.tag(14, WireType.LengthDelimited).string(message.categories[i]);
		if (message.locations !== "") writer.tag(15, WireType.LengthDelimited).string(message.locations);
		if (message.jobId !== "") writer.tag(16, WireType.LengthDelimited).string(message.jobId);
		if (message.orientation !== 0) writer.tag(17, WireType.Varint).int32(message.orientation);
		for (let i = 0; i < message.searchAfter.length; i++) writer.tag(18, WireType.LengthDelimited).string(message.searchAfter[i]);
		if (message.origins.length) {
			writer.tag(19, WireType.LengthDelimited).fork();
			for (let i = 0; i < message.origins.length; i++) writer.int32(message.origins[i]);
			writer.join();
		}
		if (message.fileType !== 0) writer.tag(20, WireType.Varint).int32(message.fileType);
		if (message.createdMin !== "") writer.tag(21, WireType.LengthDelimited).string(message.createdMin);
		if (message.createdMax !== "") writer.tag(22, WireType.LengthDelimited).string(message.createdMax);
		if (message.outsideSubscription !== false) writer.tag(23, WireType.Varint).bool(message.outsideSubscription);
		for (let i = 0; i < message.editorialTopics.length; i++) writer.tag(24, WireType.LengthDelimited).string(message.editorialTopics[i]);
		for (let i = 0; i < message.distributorNames.length; i++) writer.tag(25, WireType.LengthDelimited).string(message.distributorNames[i]);
		for (let i = 0; i < message.events.length; i++) writer.tag(26, WireType.LengthDelimited).string(message.events[i]);
		for (let i = 0; i < message.subjectTerms.length; i++) writer.tag(27, WireType.LengthDelimited).string(message.subjectTerms[i]);
		for (let i = 0; i < message.persons.length; i++) writer.tag(28, WireType.LengthDelimited).string(message.persons[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.SearchRequest
*/
const SearchRequest = new SearchRequest$Type();
var Sort$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Sort", [{
			no: 1,
			name: "field",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "descending",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.descending = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.descending = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.descending !== false) writer.tag(2, WireType.Varint).bool(message.descending);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Sort
*/
const Sort = new Sort$Type();
var SearchResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.SearchResponse", [{
			no: 1,
			name: "page",
			kind: "message",
			T: () => Page
		}, {
			no: 3,
			name: "data",
			kind: "message",
			repeat: 2,
			T: () => MediaItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.data = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.page = Page.internalBinaryRead(reader, reader.uint32(), options, message.page);
					break;
				case 3:
					message.data.push(MediaItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.page) Page.internalBinaryWrite(message.page, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.data.length; i++) MediaItem.internalBinaryWrite(message.data[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.SearchResponse
*/
const SearchResponse = new SearchResponse$Type();
var Page$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Page", [
			{
				no: 1,
				name: "offset",
				kind: "scalar",
				T: 5
			},
			{
				no: 2,
				name: "limit",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "count",
				kind: "scalar",
				T: 5
			},
			{
				no: 4,
				name: "total",
				kind: "scalar",
				T: 5
			},
			{
				no: 5,
				name: "search_after",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.offset = 0;
		message.limit = 0;
		message.count = 0;
		message.total = 0;
		message.searchAfter = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.offset = reader.int32();
					break;
				case 2:
					message.limit = reader.int32();
					break;
				case 3:
					message.count = reader.int32();
					break;
				case 4:
					message.total = reader.int32();
					break;
				case 5:
					message.searchAfter.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.offset !== 0) writer.tag(1, WireType.Varint).int32(message.offset);
		if (message.limit !== 0) writer.tag(2, WireType.Varint).int32(message.limit);
		if (message.count !== 0) writer.tag(3, WireType.Varint).int32(message.count);
		if (message.total !== 0) writer.tag(4, WireType.Varint).int32(message.total);
		for (let i = 0; i < message.searchAfter.length; i++) writer.tag(5, WireType.LengthDelimited).string(message.searchAfter[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Page
*/
const Page = new Page$Type();
var MediaItem$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.MediaItem", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "archive",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "user_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "restrictions",
				kind: "scalar",
				T: 8
			},
			{
				no: 6,
				name: "headline",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "alt_text_accessibility",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "creator",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "keywords",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 11,
				name: "category",
				kind: "scalar",
				T: 9
			},
			{
				no: 12,
				name: "persons_shown",
				kind: "message",
				repeat: 2,
				T: () => Person
			},
			{
				no: 13,
				name: "image_rating",
				kind: "scalar",
				opt: true,
				T: 5
			},
			{
				no: 14,
				name: "title",
				kind: "scalar",
				T: 9
			},
			{
				no: 15,
				name: "date_archived",
				kind: "scalar",
				T: 9
			},
			{
				no: 16,
				name: "date_created",
				kind: "message",
				T: () => ImpreciseTimestamp
			},
			{
				no: 17,
				name: "country",
				kind: "scalar",
				T: 9
			},
			{
				no: 18,
				name: "city",
				kind: "scalar",
				T: 9
			},
			{
				no: 19,
				name: "credit_line",
				kind: "scalar",
				T: 9
			},
			{
				no: 20,
				name: "version_count",
				kind: "scalar",
				T: 5
			},
			{
				no: 21,
				name: "instructions",
				kind: "scalar",
				T: 9
			},
			{
				no: 22,
				name: "usage_terms",
				kind: "scalar",
				T: 9
			},
			{
				no: 23,
				name: "source",
				kind: "scalar",
				T: 9
			},
			{
				no: 24,
				name: "suppliers",
				kind: "scalar",
				T: 9
			},
			{
				no: 25,
				name: "image_supplier_image_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 26,
				name: "job_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 27,
				name: "file",
				kind: "message",
				T: () => File
			},
			{
				no: 28,
				name: "previews",
				kind: "message",
				repeat: 2,
				T: () => Preview
			},
			{
				no: 29,
				name: "permissions",
				kind: "message",
				T: () => Permissions
			},
			{
				no: 30,
				name: "links",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 31,
				name: "internal",
				kind: "message",
				T: () => Internal
			},
			{
				no: 32,
				name: "sort_values",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.type = "";
		message.archive = "";
		message.userId = "";
		message.restrictions = false;
		message.headline = "";
		message.description = "";
		message.altTextAccessibility = "";
		message.creator = "";
		message.keywords = [];
		message.category = "";
		message.personsShown = [];
		message.title = "";
		message.dateArchived = "";
		message.country = "";
		message.city = "";
		message.creditLine = "";
		message.versionCount = 0;
		message.instructions = "";
		message.usageTerms = "";
		message.source = "";
		message.suppliers = "";
		message.imageSupplierImageId = "";
		message.jobId = "";
		message.previews = [];
		message.links = {};
		message.sortValues = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.archive = reader.string();
					break;
				case 4:
					message.userId = reader.string();
					break;
				case 5:
					message.restrictions = reader.bool();
					break;
				case 6:
					message.headline = reader.string();
					break;
				case 7:
					message.description = reader.string();
					break;
				case 8:
					message.altTextAccessibility = reader.string();
					break;
				case 9:
					message.creator = reader.string();
					break;
				case 10:
					message.keywords.push(reader.string());
					break;
				case 11:
					message.category = reader.string();
					break;
				case 12:
					message.personsShown.push(Person.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 13:
					message.imageRating = reader.int32();
					break;
				case 14:
					message.title = reader.string();
					break;
				case 15:
					message.dateArchived = reader.string();
					break;
				case 16:
					message.dateCreated = ImpreciseTimestamp.internalBinaryRead(reader, reader.uint32(), options, message.dateCreated);
					break;
				case 17:
					message.country = reader.string();
					break;
				case 18:
					message.city = reader.string();
					break;
				case 19:
					message.creditLine = reader.string();
					break;
				case 20:
					message.versionCount = reader.int32();
					break;
				case 21:
					message.instructions = reader.string();
					break;
				case 22:
					message.usageTerms = reader.string();
					break;
				case 23:
					message.source = reader.string();
					break;
				case 24:
					message.suppliers = reader.string();
					break;
				case 25:
					message.imageSupplierImageId = reader.string();
					break;
				case 26:
					message.jobId = reader.string();
					break;
				case 27:
					message.file = File.internalBinaryRead(reader, reader.uint32(), options, message.file);
					break;
				case 28:
					message.previews.push(Preview.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 29:
					message.permissions = Permissions.internalBinaryRead(reader, reader.uint32(), options, message.permissions);
					break;
				case 30:
					this.binaryReadMap30(message.links, reader, options);
					break;
				case 31:
					message.internal = Internal.internalBinaryRead(reader, reader.uint32(), options, message.internal);
					break;
				case 32:
					message.sortValues.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap30(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.ntb.MediaItem.links");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.archive !== "") writer.tag(3, WireType.LengthDelimited).string(message.archive);
		if (message.userId !== "") writer.tag(4, WireType.LengthDelimited).string(message.userId);
		if (message.restrictions !== false) writer.tag(5, WireType.Varint).bool(message.restrictions);
		if (message.headline !== "") writer.tag(6, WireType.LengthDelimited).string(message.headline);
		if (message.description !== "") writer.tag(7, WireType.LengthDelimited).string(message.description);
		if (message.altTextAccessibility !== "") writer.tag(8, WireType.LengthDelimited).string(message.altTextAccessibility);
		if (message.creator !== "") writer.tag(9, WireType.LengthDelimited).string(message.creator);
		for (let i = 0; i < message.keywords.length; i++) writer.tag(10, WireType.LengthDelimited).string(message.keywords[i]);
		if (message.category !== "") writer.tag(11, WireType.LengthDelimited).string(message.category);
		for (let i = 0; i < message.personsShown.length; i++) Person.internalBinaryWrite(message.personsShown[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
		if (message.imageRating !== void 0) writer.tag(13, WireType.Varint).int32(message.imageRating);
		if (message.title !== "") writer.tag(14, WireType.LengthDelimited).string(message.title);
		if (message.dateArchived !== "") writer.tag(15, WireType.LengthDelimited).string(message.dateArchived);
		if (message.dateCreated) ImpreciseTimestamp.internalBinaryWrite(message.dateCreated, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
		if (message.country !== "") writer.tag(17, WireType.LengthDelimited).string(message.country);
		if (message.city !== "") writer.tag(18, WireType.LengthDelimited).string(message.city);
		if (message.creditLine !== "") writer.tag(19, WireType.LengthDelimited).string(message.creditLine);
		if (message.versionCount !== 0) writer.tag(20, WireType.Varint).int32(message.versionCount);
		if (message.instructions !== "") writer.tag(21, WireType.LengthDelimited).string(message.instructions);
		if (message.usageTerms !== "") writer.tag(22, WireType.LengthDelimited).string(message.usageTerms);
		if (message.source !== "") writer.tag(23, WireType.LengthDelimited).string(message.source);
		if (message.suppliers !== "") writer.tag(24, WireType.LengthDelimited).string(message.suppliers);
		if (message.imageSupplierImageId !== "") writer.tag(25, WireType.LengthDelimited).string(message.imageSupplierImageId);
		if (message.jobId !== "") writer.tag(26, WireType.LengthDelimited).string(message.jobId);
		if (message.file) File.internalBinaryWrite(message.file, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.previews.length; i++) Preview.internalBinaryWrite(message.previews[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
		if (message.permissions) Permissions.internalBinaryWrite(message.permissions, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
		for (let k of globalThis.Object.keys(message.links)) writer.tag(30, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.links[k]).join();
		if (message.internal) Internal.internalBinaryWrite(message.internal, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.sortValues.length; i++) writer.tag(32, WireType.LengthDelimited).string(message.sortValues[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.MediaItem
*/
const MediaItem = new MediaItem$Type();
var ImpreciseTimestamp$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.ImpreciseTimestamp", [
			{
				no: 1,
				name: "time",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "valid_timezone",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "precision",
				kind: "enum",
				T: () => ["ttab.ntb.TimestampPrecision", TimestampPrecision]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.time = "";
		message.validTimezone = false;
		message.precision = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.time = reader.string();
					break;
				case 2:
					message.validTimezone = reader.bool();
					break;
				case 3:
					message.precision = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.time !== "") writer.tag(1, WireType.LengthDelimited).string(message.time);
		if (message.validTimezone !== false) writer.tag(2, WireType.Varint).bool(message.validTimezone);
		if (message.precision !== 0) writer.tag(3, WireType.Varint).int32(message.precision);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.ImpreciseTimestamp
*/
const ImpreciseTimestamp = new ImpreciseTimestamp$Type();
var Person$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Person", [{
			no: 1,
			name: "person_name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "person_description",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.personName = "";
		message.personDescription = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.personName = reader.string();
					break;
				case 2:
					message.personDescription = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.personName !== "") writer.tag(1, WireType.LengthDelimited).string(message.personName);
		if (message.personDescription !== "") writer.tag(2, WireType.LengthDelimited).string(message.personDescription);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Person
*/
const Person = new Person$Type();
var File$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.File", [
			{
				no: 1,
				name: "size",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "height",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "width",
				kind: "scalar",
				T: 5
			},
			{
				no: 4,
				name: "mime_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "original_filename",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.size = 0n;
		message.height = 0;
		message.width = 0;
		message.mimeType = "";
		message.originalFilename = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.size = reader.int64().toBigInt();
					break;
				case 2:
					message.height = reader.int32();
					break;
				case 3:
					message.width = reader.int32();
					break;
				case 4:
					message.mimeType = reader.string();
					break;
				case 5:
					message.originalFilename = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.size !== 0n) writer.tag(1, WireType.Varint).int64(message.size);
		if (message.height !== 0) writer.tag(2, WireType.Varint).int32(message.height);
		if (message.width !== 0) writer.tag(3, WireType.Varint).int32(message.width);
		if (message.mimeType !== "") writer.tag(4, WireType.LengthDelimited).string(message.mimeType);
		if (message.originalFilename !== "") writer.tag(5, WireType.LengthDelimited).string(message.originalFilename);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.File
*/
const File = new File$Type();
var Preview$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Preview", [
			{
				no: 1,
				name: "width",
				kind: "scalar",
				T: 5
			},
			{
				no: 2,
				name: "height",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "url",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "type",
				kind: "enum",
				T: () => ["ttab.ntb.PreviewType", PreviewType]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.width = 0;
		message.height = 0;
		message.url = "";
		message.type = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.width = reader.int32();
					break;
				case 2:
					message.height = reader.int32();
					break;
				case 3:
					message.url = reader.string();
					break;
				case 4:
					message.type = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.width !== 0) writer.tag(1, WireType.Varint).int32(message.width);
		if (message.height !== 0) writer.tag(2, WireType.Varint).int32(message.height);
		if (message.url !== "") writer.tag(3, WireType.LengthDelimited).string(message.url);
		if (message.type !== 0) writer.tag(4, WireType.Varint).int32(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Preview
*/
const Preview = new Preview$Type();
var Permissions$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Permissions", [
			{
				no: 1,
				name: "edit",
				kind: "scalar",
				T: 8
			},
			{
				no: 2,
				name: "delete",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "download",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.edit = false;
		message.delete = false;
		message.download = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.edit = reader.bool();
					break;
				case 2:
					message.delete = reader.bool();
					break;
				case 3:
					message.download = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.edit !== false) writer.tag(1, WireType.Varint).bool(message.edit);
		if (message.delete !== false) writer.tag(2, WireType.Varint).bool(message.delete);
		if (message.download !== false) writer.tag(3, WireType.Varint).bool(message.download);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Permissions
*/
const Permissions = new Permissions$Type();
var Internal$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.Internal", [{
			no: 1,
			name: "origin",
			kind: "message",
			T: () => OriginInfo
		}, {
			no: 2,
			name: "item_id",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.itemId = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.origin = OriginInfo.internalBinaryRead(reader, reader.uint32(), options, message.origin);
					break;
				case 2:
					message.itemId = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.origin) OriginInfo.internalBinaryWrite(message.origin, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.itemId !== "") writer.tag(2, WireType.LengthDelimited).string(message.itemId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.Internal
*/
const Internal = new Internal$Type();
var OriginInfo$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.OriginInfo", [{
			no: 1,
			name: "key",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.key = "";
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.key = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.key !== "") writer.tag(1, WireType.LengthDelimited).string(message.key);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.OriginInfo
*/
const OriginInfo = new OriginInfo$Type();
var GetSortFieldsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetSortFieldsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetSortFieldsRequest
*/
const GetSortFieldsRequest = new GetSortFieldsRequest$Type();
var GetSortFieldsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetSortFieldsResponse", [{
			no: 1,
			name: "fields",
			kind: "message",
			repeat: 2,
			T: () => SortField
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fields = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fields.push(SortField.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.fields.length; i++) SortField.internalBinaryWrite(message.fields[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetSortFieldsResponse
*/
const GetSortFieldsResponse = new GetSortFieldsResponse$Type();
var SortField$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.SortField", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.SortField
*/
const SortField = new SortField$Type();
var StringList$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.StringList", [{
			no: 1,
			name: "values",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.values = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.values.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.values.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.values[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.StringList
*/
const StringList = new StringList$Type();
var StringMap$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.StringMap", [{
			no: 1,
			name: "entries",
			kind: "map",
			K: 9,
			V: {
				kind: "scalar",
				T: 9
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.entries = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.entries, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.ntb.StringMap.entries");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.entries)) writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.entries[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.StringMap
*/
const StringMap = new StringMap$Type();
var PreferenceValue$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.PreferenceValue", [{
			no: 1,
			name: "enabled",
			kind: "scalar",
			oneof: "value",
			T: 8
		}, {
			no: 2,
			name: "words",
			kind: "message",
			oneof: "value",
			T: () => StringList
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.value = { oneofKind: void 0 };
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.value = {
						oneofKind: "enabled",
						enabled: reader.bool()
					};
					break;
				case 2:
					message.value = {
						oneofKind: "words",
						words: StringList.internalBinaryRead(reader, reader.uint32(), options, message.value.words)
					};
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.value.oneofKind === "enabled") writer.tag(1, WireType.Varint).bool(message.value.enabled);
		if (message.value.oneofKind === "words") StringList.internalBinaryWrite(message.value.words, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.PreferenceValue
*/
const PreferenceValue = new PreferenceValue$Type();
var TranslateRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.TranslateRequest", [
			{
				no: 1,
				name: "text",
				kind: "scalar",
				oneof: "document",
				T: 9
			},
			{
				no: 2,
				name: "texts",
				kind: "message",
				oneof: "document",
				T: () => StringList
			},
			{
				no: 3,
				name: "text_map",
				kind: "message",
				oneof: "document",
				T: () => StringMap
			},
			{
				no: 4,
				name: "file_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "lang_parameter_translate",
				kind: "enum",
				T: () => [
					"ttab.ntb.LangParameterTranslate",
					LangParameterTranslate,
					"LANG_PARAMETER_TRANSLATE_"
				]
			},
			{
				no: 6,
				name: "prefs_template",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "guid",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "source_language",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "target_language",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "post_edit",
				kind: "scalar",
				T: 8
			},
			{
				no: 11,
				name: "prefs",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => PreferenceValue
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.document = { oneofKind: void 0 };
		message.fileType = "";
		message.langParameterTranslate = 0;
		message.prefsTemplate = "";
		message.guid = "";
		message.sourceLanguage = "";
		message.targetLanguage = "";
		message.postEdit = false;
		message.prefs = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = {
						oneofKind: "text",
						text: reader.string()
					};
					break;
				case 2:
					message.document = {
						oneofKind: "texts",
						texts: StringList.internalBinaryRead(reader, reader.uint32(), options, message.document.texts)
					};
					break;
				case 3:
					message.document = {
						oneofKind: "textMap",
						textMap: StringMap.internalBinaryRead(reader, reader.uint32(), options, message.document.textMap)
					};
					break;
				case 4:
					message.fileType = reader.string();
					break;
				case 5:
					message.langParameterTranslate = reader.int32();
					break;
				case 6:
					message.prefsTemplate = reader.string();
					break;
				case 7:
					message.guid = reader.string();
					break;
				case 8:
					message.sourceLanguage = reader.string();
					break;
				case 9:
					message.targetLanguage = reader.string();
					break;
				case 10:
					message.postEdit = reader.bool();
					break;
				case 11:
					this.binaryReadMap11(message.prefs, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap11(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = PreferenceValue.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.ntb.TranslateRequest.prefs");
			}
		}
		map[key ?? ""] = val ?? PreferenceValue.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document.oneofKind === "text") writer.tag(1, WireType.LengthDelimited).string(message.document.text);
		if (message.document.oneofKind === "texts") StringList.internalBinaryWrite(message.document.texts, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.document.oneofKind === "textMap") StringMap.internalBinaryWrite(message.document.textMap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.fileType !== "") writer.tag(4, WireType.LengthDelimited).string(message.fileType);
		if (message.langParameterTranslate !== 0) writer.tag(5, WireType.Varint).int32(message.langParameterTranslate);
		if (message.prefsTemplate !== "") writer.tag(6, WireType.LengthDelimited).string(message.prefsTemplate);
		if (message.guid !== "") writer.tag(7, WireType.LengthDelimited).string(message.guid);
		if (message.sourceLanguage !== "") writer.tag(8, WireType.LengthDelimited).string(message.sourceLanguage);
		if (message.targetLanguage !== "") writer.tag(9, WireType.LengthDelimited).string(message.targetLanguage);
		if (message.postEdit !== false) writer.tag(10, WireType.Varint).bool(message.postEdit);
		for (let k of globalThis.Object.keys(message.prefs)) {
			writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			PreferenceValue.internalBinaryWrite(message.prefs[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.TranslateRequest
*/
const TranslateRequest = new TranslateRequest$Type();
var TranslateResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.TranslateResponse", [
			{
				no: 1,
				name: "text",
				kind: "scalar",
				oneof: "document",
				T: 9
			},
			{
				no: 2,
				name: "texts",
				kind: "message",
				oneof: "document",
				T: () => StringList
			},
			{
				no: 3,
				name: "text_map",
				kind: "message",
				oneof: "document",
				T: () => StringMap
			},
			{
				no: 4,
				name: "guid",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.document = { oneofKind: void 0 };
		message.guid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = {
						oneofKind: "text",
						text: reader.string()
					};
					break;
				case 2:
					message.document = {
						oneofKind: "texts",
						texts: StringList.internalBinaryRead(reader, reader.uint32(), options, message.document.texts)
					};
					break;
				case 3:
					message.document = {
						oneofKind: "textMap",
						textMap: StringMap.internalBinaryRead(reader, reader.uint32(), options, message.document.textMap)
					};
					break;
				case 4:
					message.guid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document.oneofKind === "text") writer.tag(1, WireType.LengthDelimited).string(message.document.text);
		if (message.document.oneofKind === "texts") StringList.internalBinaryWrite(message.document.texts, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.document.oneofKind === "textMap") StringMap.internalBinaryWrite(message.document.textMap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.guid !== "") writer.tag(4, WireType.LengthDelimited).string(message.guid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.TranslateResponse
*/
const TranslateResponse = new TranslateResponse$Type();
var GetLanguagePrefsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetLanguagePrefsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetLanguagePrefsRequest
*/
const GetLanguagePrefsRequest = new GetLanguagePrefsRequest$Type();
var LanguagePreference$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.LanguagePreference", [
			{
				no: 1,
				name: "category",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "modify_for",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.category = "";
		message.description = "";
		message.modifyFor = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.category = reader.string();
					break;
				case 2:
					message.description = reader.string();
					break;
				case 3:
					message.modifyFor.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.category !== "") writer.tag(1, WireType.LengthDelimited).string(message.category);
		if (message.description !== "") writer.tag(2, WireType.LengthDelimited).string(message.description);
		for (let i = 0; i < message.modifyFor.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.modifyFor[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.LanguagePreference
*/
const LanguagePreference = new LanguagePreference$Type();
var GetLanguagePrefsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetLanguagePrefsResponse", [{
			no: 1,
			name: "language_prefs",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => LanguagePreference
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.languagePrefs = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.languagePrefs, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = LanguagePreference.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.ntb.GetLanguagePrefsResponse.language_prefs");
			}
		}
		map[key ?? ""] = val ?? LanguagePreference.create();
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.languagePrefs)) {
			writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			LanguagePreference.internalBinaryWrite(message.languagePrefs[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetLanguagePrefsResponse
*/
const GetLanguagePrefsResponse = new GetLanguagePrefsResponse$Type();
var GetDocumentFormatsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetDocumentFormatsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetDocumentFormatsRequest
*/
const GetDocumentFormatsRequest = new GetDocumentFormatsRequest$Type();
var DocumentFormatInfo$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.DocumentFormatInfo", [
			{
				no: 1,
				name: "file_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "file_suffixes",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 3,
				name: "mime_types",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 4,
				name: "base64_encode",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fileType = "";
		message.fileSuffixes = [];
		message.mimeTypes = [];
		message.base64Encode = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fileType = reader.string();
					break;
				case 2:
					message.fileSuffixes.push(reader.string());
					break;
				case 3:
					message.mimeTypes.push(reader.string());
					break;
				case 4:
					message.base64Encode = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.fileType !== "") writer.tag(1, WireType.LengthDelimited).string(message.fileType);
		for (let i = 0; i < message.fileSuffixes.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.fileSuffixes[i]);
		for (let i = 0; i < message.mimeTypes.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.mimeTypes[i]);
		if (message.base64Encode !== false) writer.tag(4, WireType.Varint).bool(message.base64Encode);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.DocumentFormatInfo
*/
const DocumentFormatInfo = new DocumentFormatInfo$Type();
var GetDocumentFormatsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetDocumentFormatsResponse", [{
			no: 1,
			name: "document_formats",
			kind: "message",
			repeat: 2,
			T: () => DocumentFormatInfo
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documentFormats = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documentFormats.push(DocumentFormatInfo.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.documentFormats.length; i++) DocumentFormatInfo.internalBinaryWrite(message.documentFormats[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetDocumentFormatsResponse
*/
const GetDocumentFormatsResponse = new GetDocumentFormatsResponse$Type();
var GetPreferenceTemplatesRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetPreferenceTemplatesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetPreferenceTemplatesRequest
*/
const GetPreferenceTemplatesRequest = new GetPreferenceTemplatesRequest$Type();
var GetPreferenceTemplatesResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.ntb.GetPreferenceTemplatesResponse", [{
			no: 1,
			name: "preference_templates",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => StringList
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.preferenceTemplates = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.preferenceTemplates, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = StringList.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.ntb.GetPreferenceTemplatesResponse.preference_templates");
			}
		}
		map[key ?? ""] = val ?? StringList.create();
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.preferenceTemplates)) {
			writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			StringList.internalBinaryWrite(message.preferenceTemplates[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.ntb.GetPreferenceTemplatesResponse
*/
const GetPreferenceTemplatesResponse = new GetPreferenceTemplatesResponse$Type();
/**
* @generated ServiceType for protobuf service ttab.ntb.Metadata
*/
const Metadata = new ServiceType("ttab.ntb.Metadata", [{
	name: "GetAssignment",
	options: {},
	I: GetAssignmentRequest,
	O: GetAssignmentResponse
}, {
	name: "ListAssignments",
	options: {},
	I: ListAssignmentsRequest,
	O: ListAssignmentsResponse
}]);
/**
* @generated ServiceType for protobuf service ttab.ntb.Media
*/
const Media = new ServiceType("ttab.ntb.Media", [
	{
		name: "Search",
		options: {},
		I: SearchRequest,
		O: SearchResponse
	},
	{
		name: "GetItem",
		options: {},
		I: GetItemRequest,
		O: GetItemResponse
	},
	{
		name: "GetSortFields",
		options: {},
		I: GetSortFieldsRequest,
		O: GetSortFieldsResponse
	}
]);
/**
* @generated ServiceType for protobuf service ttab.ntb.Nynorsk
*/
const Nynorsk = new ServiceType("ttab.ntb.Nynorsk", [
	{
		name: "Translate",
		options: {},
		I: TranslateRequest,
		O: TranslateResponse
	},
	{
		name: "GetLanguagePrefs",
		options: {},
		I: GetLanguagePrefsRequest,
		O: GetLanguagePrefsResponse
	},
	{
		name: "GetDocumentFormats",
		options: {},
		I: GetDocumentFormatsRequest,
		O: GetDocumentFormatsResponse
	},
	{
		name: "GetPreferenceTemplates",
		options: {},
		I: GetPreferenceTemplatesRequest,
		O: GetPreferenceTemplatesResponse
	}
]);
//#endregion
//#region src/ntb/service.client.ts
/**
* Metadata service for retrieving assignment metadata.
*
* @generated from protobuf service ttab.ntb.Metadata
*/
var MetadataClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Metadata.typeName;
		this.methods = Metadata.methods;
		this.options = Metadata.options;
	}
	/**
	* GetAssignment returns metadata for a specific assignment.
	*
	* @generated from protobuf rpc: GetAssignment
	*/
	getAssignment(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListAssignments returns metadata for all assignments.
	*
	* @generated from protobuf rpc: ListAssignments
	*/
	listAssignments(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* Media service for interacting with the NTB media manager archive. Experimental.
*
* @generated from protobuf service ttab.ntb.Media
*/
var MediaClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Media.typeName;
		this.methods = Media.methods;
		this.options = Media.options;
	}
	/**
	* Search in a media archive.
	*
	* @generated from protobuf rpc: Search
	*/
	search(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetItem fetches a single media item.
	*
	* @generated from protobuf rpc: GetItem
	*/
	getItem(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetSortFields returns the available sort fields.
	*
	* @generated from protobuf rpc: GetSortFields
	*/
	getSortFields(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* Nynorsk service for translating documents using Nynorskroboten.
*
* @generated from protobuf service ttab.ntb.Nynorsk
*/
var NynorskClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Nynorsk.typeName;
		this.methods = Nynorsk.methods;
		this.options = Nynorsk.options;
	}
	/**
	* Translate translates a document between Scandinavian languages.
	*
	* @generated from protobuf rpc: Translate
	*/
	translate(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetLanguagePrefs returns the available optional language forms.
	*
	* @generated from protobuf rpc: GetLanguagePrefs
	*/
	getLanguagePrefs(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetDocumentFormats returns the supported document formats.
	*
	* @generated from protobuf rpc: GetDocumentFormats
	*/
	getDocumentFormats(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetPreferenceTemplates returns the available preference templates and the
	* language forms they enable.
	*
	* @generated from protobuf rpc: GetPreferenceTemplates
	*/
	getPreferenceTemplates(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
//#endregion
export { Assignment, DocumentFormatInfo, File, FileType, GetAssignmentRequest, GetAssignmentResponse, GetDocumentFormatsRequest, GetDocumentFormatsResponse, GetItemRequest, GetItemResponse, GetLanguagePrefsRequest, GetLanguagePrefsResponse, GetPreferenceTemplatesRequest, GetPreferenceTemplatesResponse, GetSortFieldsRequest, GetSortFieldsResponse, ImpreciseTimestamp, Internal, LangParameterTranslate, LanguagePreference, ListAssignmentsRequest, ListAssignmentsResponse, Location, Media, MediaClient, MediaItem, Metadata, MetadataClient, Nynorsk, NynorskClient, Orientation, Origin, OriginInfo, Page, Permissions, Person, PreferenceValue, Preview, PreviewType, SearchRequest, SearchResponse, Sort, SortField, StringList, StringMap, TimestampPrecision, TranslateRequest, TranslateResponse };
